<template>
  <v-row>
    <v-col cols="12" md="12">
      <div class="text-subtitle-1 font-weight-bold">Event format</div>
    </v-col>
    <v-col
      cols="12"
      v-for="item in eventFormatOptions"
      :key="`cols${item.value}`"
    >
      <v-sheet
        :key="`format${item.value}`"
        height="80"
        width="350"
        :outlined="currentEvent.type != item.value"
        :color="currentEvent.type == item.value ? '#FEF3EE' : ''"
        :class="[
          'rounded-lg d-flex flex-column justify-center align-center cursor-pointer',
          {
            'selected-event-format primary--text':
              currentEvent.type == item.value,
          },
        ]"
        @click="currentEvent.type = item.value"
        ><div>{{ item.text }}</div>

        <div class="grey--text text-caption">{{ item.subtitle }}</div>
      </v-sheet>
    </v-col>
  </v-row>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  computed: {
    ...mapGetters(["currentEvent"]),
  },
  data() {
    return {
      eventFormatOptions: [
        { text: "Online", value: "online", subtitle: "" },
        { text: "In-person", value: "in-person", subtitle: "" },
        { text: "Hybrid", value: "hybrid", subtitle: "Online + In-Person" },
      ],
    };
  },
  mounted() {
    this.$emit("validatePage", "EventFormat", this);
  },
  methods: {
    validatePage() {
      return true;
    },
  },
};
</script>

<style>
.selected-event-format {
  border: 2px solid #f15f31 !important;
}
</style>